import React from "react";
import VisualPageTemplate from "../organisms/VisualPageTemplate";

const NotFound = () => {
  React.useEffect(() => {
    document.title = "VTubers - 404 Not Found";
  });
  return (
    <VisualPageTemplate title={"404 Not Found"}>
      <p>
        指定されたページは存在しないかアクセスできません。入力されたURLが正しいかご確認ください
      </p>
    </VisualPageTemplate>
  );
};

export default NotFound;
